var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-button"},[_vm._t("default"),_vm._v(" "),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.openInfoModal()}}},[_vm._v("Info")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }